import useUser from "hooks/useUser"

const useUserSettings = () => {
  return useUser()?.settings
}

export default useUserSettings
